export enum CloseSource {
  CloseInMis = 20, // mis操作关闭；
  InitiativeClose, // 用户主动关闭；
  CloseInPacific, // 太平洋操作关闭
}

export enum OpenScene {
  GuideOpen = 1, // 引导页开启
  SettingsOpen, // 设置页开启
  AfterPayOpen, // 支付后开启
  OpenClickPayGuide, // 引导二次弹窗后开启
  DefaultScene = 999, // 兜底值，业务方未传入均归类到此值
}

export enum GuideOpenScene {
  BindCard = 1,
  VerifyPassword,
  OneClickDetail,
  RiskDeny,
  StayInCurrentPage,
}

export enum PayType {
  WXpay = 1,
  MTpay,
  Alipay,
}

export const payTypeText = {
  1: '微信支付',
  2: '美团支付',
  3: '支付宝支付',
};
// 是否支持营销
export enum Market {
  support = 1,
  unsupported,
}
// 是否优先优惠支付
export enum MarketPriority {
  Discount = 1,
  DIY = 2,
}

export const SYSTEM_RECOMMEND_PAY_TYPE = 0;

// 是否展示美团月付入口
// 是否优先优惠支付，供组件使用
export const marketPriority = {
  priority: 1,
  notPriority: 2,
};

// 是否展示美团月付入口
export enum MaidanEntry {
  show = 1,
  hide,
}

// 是否展示美团月付入口
export enum NoticeFlag {
  show = 1,
  hide,
}

// 是否支持信用卡
export enum SupportType {
  denyCredit = 1,
  supportCredit,
  denyAllCard,
}

// TTI 测速点
export enum TTIPoint {
  position = 20, // tti项目统一选择测速点21，便于统一上报大盘数据
  neoPosition = 21, // NEO TTI点位
  memberIdPosition = 22, // 统计memberid的耗时
}

export enum ExceptionCategory {
  Entry = '【入口】',
  Log = '【日志】',
  Expect = '【预期流程埋点】',
  Exception = '【异常流程埋点】',
  PageException = '【页面流程】',
  CustomBridge = '【自定义桥】',
  KNBBridge = '【KNB 桥】',
  VueErrorHandler = '【vueErrorHandler】',
}

export enum PageStyle {
  FullPage = 'page',
  ModalPage = 'pop',
}

export enum HalfScreenType {
  OneClickPay = 1, // 已开启可用+说明类型弹窗
  OneClickPayAdjustPayList = 2, // 已开启可使用调整扣款顺序弹窗
  OpenOneClickPayAdjustPayList = 4, // 未开启可引导+调整扣款顺序弹窗
  OneClickPayAdjustLimit = 6, // 已开启调额
  OneClickPayAdjustLimitTest = 7, // 已开启调额 + 扣款顺序调整
  OneClickPayNewPage = 10,
  OneClickPayLoyalCustomerPage = 11, // 已开通 + 调额 + 免密授权
}

export const enum OneClickModalBridge {
  OpenOneClickPay = 'pay.openOneClickPay',
  NotifyRender = 'neohybrid.notifyRender',
}

export const enum DowngradeBridgeAction {
  CashierDowngrade = 'notify_downgrade',
}

export const enum OneClickModalBridgeAction {
  OpenOneClickPaySign = 'OpenOneClickPaySign', // 未开通未设置顺序-新流程
  OpenOneClickPay = 'openOneClickPay', // （开通并设置顺序）-未开通未设置顺序
  AbandonOpenClickPay = 'abandonOpenClickPay', // （用户放弃开开启极速支付）-未开通取消，已开通取消
  StartOneClickPay = 'startOneClickPay', // （开启极速支付）已开通，支付
  AdjustPayTypeList = 'adjustPayTypeList', // (调整扣款顺序）已开通调整
  processOneClickPay = 'processOneClickPay', // 已开通，验密支付
}

export enum PayChannel {
  OpenOneClickPaySign = 'OpenOneClickPaySign', // （开通并设置顺序）-未开通未设置顺序-新流程
  OpenOneClickPay = 'OpenOneClickPay', // （开通并设置顺序）-未开通未设置顺序
  AbandonOpenClickPay = 'AbandonOpenClickPay', // （用户放弃开开启极速支付）-未开通取消，已开通取消
  StartOneClickPay = 'StartOneClickPay', // （开启极速支付）已开通，支付
  AdjustPayTypeList = 'AdjustPayTypeList', // （调整扣款顺序）已开通调整
  processOneClickPay = 'processOneClickPay', // 已开通，验密支付
}
/** 弹窗类型1、2，4(未开启引导弹窗) */
export enum ApiActioninfoAction {
  /** 是-确认支付 */
  ensurepay = 'ensurepay',
  /** 否-降级 */
  degradestd = 'degradestd',
  /** 高优组件 */
  highPriorGuideExposure = 'highPriorGuideExposure',
}
// 高优引导模块曝光后, actionInfo接口传递的 expose_scene 字段
export enum ApiActioninfoExposeScene {
  /** 是-确认支付 */
  deductOrderPage = 'deduct-order-page', // 扣款顺序管理页
}

export enum CashierType {
  oneclick = 'oneclick',
}

export enum Runtime {
  Prod,
  Staging,
  Test,
  Dev,
  Local,
}

export enum OpenPageStyle {
  Origin = '',
  Full = 'full',
  HalfPage = 'half_page',
}

export enum HalfScreenWindowStyle {
  OldStyle = 'oldStyle',
  NewBStyle = 'newBStyle',
  NewCStyle = 'newCStyle',
  NewDStyle = 'newDStyle',
  NewEStyle = 'newEStyle',
  OpenGuideV3Style = 'openGuideV3Style',
  newStyle = 'newStyle',
}

// 用户关闭极速支付
export const CLOSE_ONECLICKPAY = 'CLOSE_ONECLICKPAY';

// 用户开通极速支付，命中验密流程
export const OPEN_ONECLICKPAY_BY_PASSWORD = 'OPEN_ONECLICKPAY_BY_PASSWORD';

// 用户打开调额页面，命中验密流程
export const OPEN_QUATO_BY_PASSWORD = 'OPEN_QUATO_BY_PASSWORD';

// 用户开通极速支付，命中绑卡流程
export const OPEN_ONECLICKPAY_BY_BINDCARD = 'OPEN_ONECLICKPAY_BY_BINDCARD';

export const ONECLICKPAY_SERIAL_CODE = 'ONECLICKPAY_SERIAL_CODE';

// 用户打开扣款顺序页面，需要回来时刷新
export const OPEN_DEDUCTION_ORDER = 'OPEN_DEDUCTION_ORDER';

// 用户开通后，调整额度，回到首页时需要刷新
export const OPEN_QUOTO = 'OPEN_QUOTO';

// 扣款顺序调整调用接口
export enum TopPaySubTypeUrl {
  TopPaySubTypeNoPromo = '/deductOrder/topPaySubType', // 不需要发奖请求的接口
  TopPaySubTypePromo = '/cashier/sethighpriority', // 需要发奖的接口
  TopPaySubTypePromoForHalfDeductionOrder = '/cashier/actionprocess', // 需要发奖的接口,适用于扣款顺序半页
}
// 推荐支付方式区域 null - 不展示 1 - 系统推荐 2 - 用户自定义
export enum PriorityRecommendType {
  SYSTEM = 1, // 系统推荐
  MANUAL = 2, // 用户自主设置
}

export enum PrioritySource {
  MAIDAN = 2, // "月付(买单)"
  MAIDAN_UI = 5, // "美团月付页面一键置顶"
  CO_BRANDED_CARD_UI = 6, // "联名卡页面一键置顶"
  BALANCE_PLUS_UI = 7, // "零钱+页面一键置顶"
  DCEP_TOP = 20, // "数字货币页面一键置顶"
  PAY_AFTER_TOP = 30, // "支付成功页一键置顶"
  SETTING_PAGE_TOP = 31, // "支付设置页一键置顶"
  CREDITPAY_UI_REFACTOR = 40, // "重构月付页面一键置顶"
}
// 业务纬度扣款顺序场景下，当前支付方式是否不可用，0代表不可用，1代表可用
export enum PayModeAvailableStatus {
  unavailable,
  available,
}
// 高优引导模块样式类型
export enum PayTypeGuideStyleNameType {
  oldStyle = 'oldStyle', // 对照组
  redPacketStyleWithCashTicket = 'redPacketStyleWithCashTicket', // 实验组二，红包样式，无现金券
  redPacketStyleWithOpenGuideCashTicket = 'redPacketStyleWithOpenGuideCashTicket', // 极速支付开通，减营销红卡样式
}
export const enum ButtonType {
  UpBtn = 'upBtn',
  DownBtn = 'DownBtn',
}
export enum SceneType {
  halfDeductionOrder = 'halfDeductionOrder',
  oneClickModal = 'oneClickModal',
}
// 免验授权状态
export enum NoAuthStatus {
  HIDDEN = 0, // 不展示免验模块
  ENABLED = 1, // 开启免验
  DISABLED = 2, // 关闭免验
}

// 取消操作类型
export enum CancelType {
  ChangePayment = 'changePayment', // 更改付款方式
  Close = 'close', // 关闭弹窗
}
